module.exports = __webpack_public_path__ + "static/media/14.0743d20f.jpg";